import { Endpoints } from "@typeConfigs/endpoints";

const BASE_URL_DEVELOPMENT = "http://localhost:7171";
const BASE_URL_DOCKER = "http://localhost:7171";
const BASE_URL_PRODUCTION = "https://markosapps.mk";

const ADMIN_CONTROLLER_PREFIX = "api/admin";
const AUTH_CONTROLLER_PREFIX = "api/auth";
const USER_CONTROLLER_PREFIX = "api/user";
const POST_CONTROLLER_PREFIX = "api/post";
const MESSAGING_CONTROLLER_PREFIX = "api/messaging";
const POST_HUB = "postHub";
const MESSAGE_HUB = "messageHub";
const ADMIN_HUB = "adminHub";

const ENDPOINTS: Endpoints = {
  // Admin
  GET_ROLES_FOR_EMAIL: `${ADMIN_CONTROLLER_PREFIX}/roles`,
  GET_DASHBOARD: `${ADMIN_CONTROLLER_PREFIX}/dashboard`,
  DELETE_USER: (id: string) => `${ADMIN_CONTROLLER_PREFIX}/users/${id}`,
  UPDATE_USER_ROLES: `${ADMIN_CONTROLLER_PREFIX}/roles`,

  // Auth
  LOGIN: `${AUTH_CONTROLLER_PREFIX}/login`,
  REGISTER: `${AUTH_CONTROLLER_PREFIX}/register`,
  VALIDATE: `${AUTH_CONTROLLER_PREFIX}/validate`,

  // User
  GET_USERS: `${USER_CONTROLLER_PREFIX}/all`,
  GET_USER: (id: string) => `${USER_CONTROLLER_PREFIX}/${id}`,

  // Posts
  GET_POSTS: `${POST_CONTROLLER_PREFIX}/all`,
  GET_POST_BY_ID: (id: string) => `${POST_CONTROLLER_PREFIX}/${id}`,
  CREATE_POST: POST_CONTROLLER_PREFIX,
  UPDATE_POST: (id: string) => `${POST_CONTROLLER_PREFIX}/${id}`,
  DELETE_POST: (id: string) => `${POST_CONTROLLER_PREFIX}/${id}`,

  // Messaging
  GET_CHATS: `${MESSAGING_CONTROLLER_PREFIX}/chats`,
  START_CHAT: (id: string) => `${MESSAGING_CONTROLLER_PREFIX}/chats/user/${id}`,
  SEND_MESSAGE: `${MESSAGING_CONTROLLER_PREFIX}/send`,

  // Hubs
  POST_HUB: POST_HUB,
  MESSAGE_HUB: MESSAGE_HUB,
  ADMIN_HUB: ADMIN_HUB,
};

const developmentEndpoints: Endpoints = {
  // Admin
  GET_ROLES_FOR_EMAIL: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_ROLES_FOR_EMAIL}`,
  GET_DASHBOARD: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_DASHBOARD}`,
  DELETE_USER: (id: string) => `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.DELETE_USER(id)}`,
  UPDATE_USER_ROLES: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.UPDATE_USER_ROLES}`,

  // Auth
  LOGIN: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.LOGIN}`,
  REGISTER: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.REGISTER}`,
  VALIDATE: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.VALIDATE}`,

  // User
  GET_USERS: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_USERS}`,
  GET_USER: (id: string) => `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_USER(id)}`,

  // Posts
  GET_POSTS: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_POSTS}`,
  GET_POST_BY_ID: (id: string) =>
    `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_POST_BY_ID(id)}`,
  CREATE_POST: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.CREATE_POST}`,
  UPDATE_POST: (id: string) => `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.UPDATE_POST(id)}`,
  DELETE_POST: (id: string) => `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.DELETE_POST(id)}`,

  // Messaging
  GET_CHATS: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.GET_CHATS}`,
  START_CHAT: (id: string) => `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.START_CHAT(id)}`,
  SEND_MESSAGE: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.SEND_MESSAGE}`,

  // Hubs
  POST_HUB: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.POST_HUB}`,
  MESSAGE_HUB: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.MESSAGE_HUB}`,
  ADMIN_HUB: `${BASE_URL_DEVELOPMENT}/${ENDPOINTS.ADMIN_HUB}`,
};

const dockerEndpoints: Endpoints = {
  // Admin
  GET_ROLES_FOR_EMAIL: `${BASE_URL_DOCKER}/${ENDPOINTS.GET_ROLES_FOR_EMAIL}`,
  GET_DASHBOARD: `${BASE_URL_DOCKER}/${ENDPOINTS.GET_DASHBOARD}`,
  DELETE_USER: (id: string) => `${BASE_URL_DOCKER}/${ENDPOINTS.DELETE_USER(id)}`,
  UPDATE_USER_ROLES: `${BASE_URL_DOCKER}/${ENDPOINTS.UPDATE_USER_ROLES}`,

  // Auth
  LOGIN: `${BASE_URL_DOCKER}/${ENDPOINTS.LOGIN}`,
  REGISTER: `${BASE_URL_DOCKER}/${ENDPOINTS.REGISTER}`,
  VALIDATE: `${BASE_URL_DOCKER}/${ENDPOINTS.VALIDATE}`,

  // User
  GET_USERS: `${BASE_URL_DOCKER}/${ENDPOINTS.GET_USERS}`,
  GET_USER: (id: string) => `${BASE_URL_DOCKER}/${ENDPOINTS.GET_USER(id)}`,

  // Posts
  GET_POSTS: `${BASE_URL_DOCKER}/${ENDPOINTS.GET_POSTS}`,
  GET_POST_BY_ID: (id: string) => `${BASE_URL_DOCKER}/${ENDPOINTS.GET_POST_BY_ID(id)}`,
  CREATE_POST: `${BASE_URL_DOCKER}/${ENDPOINTS.CREATE_POST}`,
  UPDATE_POST: (id: string) => `${BASE_URL_DOCKER}/${ENDPOINTS.UPDATE_POST(id)}`,
  DELETE_POST: (id: string) => `${BASE_URL_DOCKER}/${ENDPOINTS.DELETE_POST(id)}`,

  // Messaging
  GET_CHATS: `${BASE_URL_DOCKER}/${ENDPOINTS.GET_CHATS}`,
  START_CHAT: (id: string) => `${BASE_URL_DOCKER}/${ENDPOINTS.START_CHAT(id)}`,
  SEND_MESSAGE: `${BASE_URL_DOCKER}/${ENDPOINTS.SEND_MESSAGE}`,

  // Hubs
  POST_HUB: `${BASE_URL_DOCKER}/${ENDPOINTS.POST_HUB}`,
  MESSAGE_HUB: `${BASE_URL_DOCKER}/${ENDPOINTS.MESSAGE_HUB}`,
  ADMIN_HUB: `${BASE_URL_DOCKER}/${ENDPOINTS.ADMIN_HUB}`,
};

const productionEndpoints: Endpoints = {
  // Admin
  GET_ROLES_FOR_EMAIL: `${BASE_URL_PRODUCTION}/${ENDPOINTS.GET_ROLES_FOR_EMAIL}`,
  GET_DASHBOARD: `${BASE_URL_PRODUCTION}/${ENDPOINTS.GET_DASHBOARD}`,
  DELETE_USER: (id: string) => `${BASE_URL_PRODUCTION}/${ENDPOINTS.DELETE_USER(id)}`,
  UPDATE_USER_ROLES: `${BASE_URL_PRODUCTION}/${ENDPOINTS.UPDATE_USER_ROLES}`,

  // Auth
  LOGIN: `${BASE_URL_PRODUCTION}/${ENDPOINTS.LOGIN}`,
  REGISTER: `${BASE_URL_PRODUCTION}/${ENDPOINTS.REGISTER}`,
  VALIDATE: `${BASE_URL_PRODUCTION}/${ENDPOINTS.VALIDATE}`,

  // User
  GET_USERS: `${BASE_URL_PRODUCTION}/${ENDPOINTS.GET_USERS}`,
  GET_USER: (id: string) => `${BASE_URL_PRODUCTION}/${ENDPOINTS.GET_USER(id)}`,

  // Posts
  GET_POSTS: `${BASE_URL_PRODUCTION}/${ENDPOINTS.GET_POSTS}`,
  GET_POST_BY_ID: (id: string) =>
    `${BASE_URL_PRODUCTION}/${ENDPOINTS.GET_POST_BY_ID(id)}`,
  CREATE_POST: `${BASE_URL_PRODUCTION}/${ENDPOINTS.CREATE_POST}`,
  UPDATE_POST: (id: string) => `${BASE_URL_PRODUCTION}/${ENDPOINTS.UPDATE_POST(id)}`,
  DELETE_POST: (id: string) => `${BASE_URL_PRODUCTION}/${ENDPOINTS.DELETE_POST(id)}`,

  // Messaging
  GET_CHATS: `${BASE_URL_PRODUCTION}/${ENDPOINTS.GET_CHATS}`,
  START_CHAT: (id: string) => `${BASE_URL_PRODUCTION}/${ENDPOINTS.START_CHAT(id)}`,
  SEND_MESSAGE: `${BASE_URL_PRODUCTION}/${ENDPOINTS.SEND_MESSAGE}`,

  // Hubs
  POST_HUB: `${BASE_URL_PRODUCTION}/${ENDPOINTS.POST_HUB}`,
  MESSAGE_HUB: `${BASE_URL_PRODUCTION}/${ENDPOINTS.MESSAGE_HUB}`,
  ADMIN_HUB: `${BASE_URL_PRODUCTION}/${ENDPOINTS.ADMIN_HUB}`,
};

let endpoints: Endpoints;

switch (process.env.NODE_ENV) {
  case "development":
    endpoints = developmentEndpoints;
    break;

  case "docker":
    endpoints = dockerEndpoints;
    break;

  case "production":
    endpoints = productionEndpoints;
    break;

  default:
    endpoints = developmentEndpoints;
    break;
}

export const ENDPOINT_URLS: Endpoints = endpoints;
